import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router';
import { DEFAULT_FONT_HREF } from '@sunfish/lib/branding/fonts';
import './tailwind.css';
import { NavigationProgress } from './components/navigation-progress';
import { ThemeScript } from '~providers/theme-provider';

export function headers() {
	return {
		'Cache-Control': 'no-cache, no-store, must-revalidate',
	};
}

export function meta() {
	return [
		{
			name: 'view-transition',
			content: 'same-origin'
		}
	];
}

export function links() {
	return [
		{ rel: 'apple-touch-icon', href: '/apple-touch-icon.png', sizes: '180x180' },
		{ rel: 'preconnect', href: 'https://fonts.googleapis.com' },
		{ rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
		{ rel: 'stylesheet', href: DEFAULT_FONT_HREF }
	];
}

export default function App() {
	return (
		<html lang="en">
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<Meta />
				<Links />
				<ThemeScript />
			</head>
			<body>
				<NavigationProgress />
				<Outlet />
				<ScrollRestoration />
				<Scripts />
			</body>
		</html>
	);
}
